import { render, staticRenderFns } from "./Africas.vue?vue&type=template&id=d4abd770&"
import script from "./Africas.vue?vue&type=script&lang=js&"
export * from "./Africas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports